import Swal from "sweetalert2";
import { store, persistor } from "../Store/store";
import { thunk_reset_user } from "../Action/action";
import * as UserService from "../Services/User/UserService";

const SESSION_EXPIRED_FLAG = "pp_session_expired";
let isSessionEnding = false;

export const isSessionEnded = () => isSessionEnding;

export const logoutUser = () => {
  UserService.Logout()
    .catch(() => {})
    .finally(() => {
      store.dispatch(thunk_reset_user({}));
      sessionStorage.clear();
      window.location.href = "/";
    });
};

export const endSession = () => {
  if (isSessionEnding) {
    return;
  }
  isSessionEnding = true;

  store.dispatch(thunk_reset_user({}));
  sessionStorage.clear();
  sessionStorage.setItem(SESSION_EXPIRED_FLAG, "1");

  Promise.resolve(persistor.flush())
    .catch(() => {})
    .finally(() => {
      window.location.replace("/");
    });
};

export const showSessionExpiredMessage = () => {
  if (sessionStorage.getItem(SESSION_EXPIRED_FLAG)) {
    sessionStorage.removeItem(SESSION_EXPIRED_FLAG);
    Swal.fire({
      icon: "warning",
      title: "Session Expired",
      text: "Your session has expired. Please login again.",
      confirmButtonText: "OK",
    });
  }
};
